import request from '@/utils/request'


// 餐饮接口

// 创建餐厅：post restaurant/create，参数：
// title // 标题
// avatar // 封面图片
// imageList // 轮播图片列表
// text // 详情
// tel // 联系电话
// address // 地址
// shipTypehoodList // 配送类型列表,[1,...],1：堂食，2：打包，3：外卖
// order// 排序
export function create(data) {
    return request({
        url: '/restaurant/create',
        method: 'post',
        data,
    })
  }
// 修改餐厅：post restaurant/update，参数：
// restaurantId // 餐厅ID
// title // 标题
// avatar // 封面图片
// imageList // 轮播图片列表
// text // 详情
// tel // 联系电话
// address // 地址
// shipTypehoodList // 配送类型列表,[1,...],1：堂食，2：打包，3：外卖
// order// 排序
export function update(data) {
    return request({
        url: '/restaurant/update',
        method: 'post',
        data,
    })
  }
// 删除餐厅：post restaurant/remove，参数：
// restaurantId // 餐厅ID
export function remove(data) {
    return request({
        url: '/restaurant/remove',
        method: 'post',
        data,
    })
  }
// 获取单个餐厅：get restaurant/find，参数：
// restaurantId // 餐厅ID
export function find(params) {
    return request({
        url: '/restaurant/find',
        method: 'get',
        params,
    })
  }
// 获取餐厅列表：get restaurant/findList，参数：
// page
// size
// keyword // 关键词，按标题搜索
export function findList(params) {
    return request({
        url: '/restaurant/findList',
        method: 'get',
        params,
    })
  }
// 获取所有餐厅：get restaurant/findAll，参数：
// keyword // 关键词，按标题搜索
export function findAll(params) {
    return request({
        url: '/restaurant/findAll',
        method: 'get',
        params,
    })
  }
// 新增餐桌：post restaurant/createDesk，参数：
// title // 标题
// restaurantId // 餐厅ID
// order // 排序
export function createDesk(data) {
    return request({
        url: '/restaurant/createDesk',
        method: 'post',
        data,
    })
  }
// 修改餐桌：post restaurant/updateDesk，参数：
// deskId // 餐桌ID
// title // 标题
// order // 排序
export function updateDesk(data) {
    return request({
        url: '/restaurant/updateDesk',
        method: 'post',
        data,
    })
  }
// 删除餐桌：post restaurant/removeDesk，参数：
// deskId // 餐桌ID
export function removeDesk(data) {
    return request({
        url: '/restaurant/removeDesk',
        method: 'post',
        data,
    })
  }
// 获取单个餐桌：get restaurant/findDesk，参数：
// deskId // 餐桌ID
export function findDesk(params) {
    return request({
        url: '/restaurant/findDesk',
        method: 'get',
        params,
    })
  }
// 获取餐桌列表：get restaurant/findDeskList，参数：
// page
// size
// keywork // 关键词，搜索标题
// restaurantId // 餐厅Id
export function findDeskList(params) {
    return request({
        url: '/restaurant/findDeskList',
        method: 'get',
        params,
    })
  }
// 获取所有餐桌：get restaurant/findDeskAll，参数：
// keywork // 关键词，搜索标题
// restaurantId // 餐厅Id
export function findDeskAll(params) {
    return request({
        url: '/restaurant/findDeskAll',
        method: 'get',
        params,
    })
  }
// 新增菜品：post restaurant/createDish，参数：
// title // 标题
// restaurantIdList // 餐厅ID列表，[]
// avatar // 封面图片
// imageList // 轮播图列表,[]
// tagIdList // 菜品标签列表，[]
// defaultPrice // 菜品价格
// unit // 单位
// dailyStock // 日库存
// totalStock // 总库存
// printerIdList // 打印机列表,[]
// text // 说明
// order // 排序
export function createDish(data) {
    return request({
        url: '/restaurant/createDish',
        method: 'post',
        data,
    })
  }
// 修改菜品：post restaurant/updateDish，参数：
// dishId // 菜品ID
// title // 标题
// restaurantIdList // 餐厅ID列表，[]
// avatar // 封面图片
// imageList // 轮播图列表,[]
// tagIdList // 菜品标签列表，[]
// defaultPrice // 菜品价格
// unit // 单位
// dailyStock // 日库存
// totalStock // 总库存
// printerIdList // 打印机列表,[]
// text // 说明
// order // 排序
export function updateDish(data) {
    return request({
        url: '/restaurant/updateDish',
        method: 'post',
        data,
    })
  }
// 删除菜品：post restaurant/removeDish，参数：
// dishId // 菜品ID
export function removeDish(data) {
    return request({
        url: '/restaurant/removeDish',
        method: 'post',
        data,
    })
  }
// 获取单个菜品：get restaurant/findDish，参数：
// dishId // 菜品ID
export function findDish(params) {
    return request({
        url: '/restaurant/findDish',
        method: 'get',
        params,
    })
  }
// 获取菜品列表：get restaurant/findDishList，参数：
// page
// size
// keywork // 关键词，搜索标题
// restaurantId // 餐厅Id
export function findDishList(params) {
    return request({
        url: '/restaurant/findDishList',
        method: 'get',
        params,
    })
  }
// 获取所有菜品：get restaurant/findDishAll，参数：
// keywork // 关键词，搜索标题
// restaurantId // 餐厅Id
export function findDishAll(params) {
    return request({
        url: '/restaurant/findDishAll',
        method: 'get',
        params,
    })
  }
// 新增菜品标签：post restaurant/createTag，参数：
// title // 标题
// icon // 图标
// restaurantIdList // 餐厅ID列表，[]
// printerIdList // 打印机列表,[]
// order // 排序
export function createTag(data) {
    return request({
        url: '/restaurant/createTag',
        method: 'post',
        data,
    })
  }
// 修改菜品标签：post restaurant/updateTag，参数：
// dishId // 菜品ID
// title // 标题
// icon // 图标
// restaurantIdList // 餐厅ID列表，[]
// printerIdList // 打印机列表,[]
// order // 排序
export function updateTag(data) {
    return request({
        url: '/restaurant/updateTag',
        method: 'post',
        data,
    })
  }
// 删除菜品标签：post restaurant/removeTag，参数：
// dishId // 菜品ID
export function removeTag(data) {
    return request({
        url: '/restaurant/removeTag',
        method: 'post',
        data,
    })
  }
// 获取单个菜品标签：get restaurant/findTag，参数：
// dishId // 菜品ID
export function findTag(params) {
    return request({
        url: '/restaurant/findTag',
        method: 'get',
        params,
    })
  }
// 获取菜品标签列表：get restaurant/findTagList，参数：
// page
// size
// keywork // 关键词，搜索标题
// restaurantId // 餐厅Id
export function findTagList(params) {
    return request({
        url: '/restaurant/findTagList',
        method: 'get',
        params,
    })
  }
// 获取所有菜品标签：get restaurant/findTagAll，参数：
// keywork // 关键词，搜索标题
// restaurantId // 餐厅Id
export function findTagAll(params) {
    return request({
        url: '/restaurant/findTagAll',
        method: 'get',
        params,
    })
  }

  // 
  // 获取单个订单：get restaurant/findOrder, 参数：
  // orderId // 订单号
  export function findOrder(params) {
    return request({
        url: '/restaurant/findOrder',
        method: 'get',
        params,
    })
  }
  // 获取我的订单列表（小程序端）:get restaurant/findMyOrderList, 参数：
  // page,
  // size
  // step // 状态，1：待付款，2：已付款，4，已核销，5，已退款
  export function findMyOrderList(params) {
    return request({
        url: '/restaurant/findMyOrderList',
        method: 'get',
        params,
    })
  }
  // 后台获取订单列表：get restaurant/findOrderList, 参数：
  // page,
  // size
  // step // 状态，1：待付款，2：已付款，4，已核销，5，已退款
  // keyword // 关键词，搜索订单号，订单名称等
  export function findOrderList(params) {
    return request({
        url: '/restaurant/findOrderList',
        method: 'get',
        params,
    })
  }
  // 核销订单：post restaurant/finishOrder , 参数：
  // orderId
  export function finishOrder(data) {
    return request({
        url: '/restaurant/finishOrder',
        method: 'post',
        data,
    })
  }
  // 订单退款：post restaurant/refundOrder, 参数：
  // orderId
  // refundAmount // 退款金额
  export function refundOrder(data) {
    return request({
        url: '/restaurant/refundOrder',
        method: 'post',
        data,
    })
  }

